// extracted by mini-css-extract-plugin
export default {"avatar":"UserAvatar_avatar__oxNZq","letter":"UserAvatar_letter__GK2W3"};